export const escapeIdStart = '$@#!';
export const escapeIdEnd = '!#@$';
export const startRe = /\$@#!/gu;
export const endRe = /!#@\$/gu;
export const fullRe = new RegExp(`${startRe.source}(?<value>\\d+)${endRe.source}`, 'u');